import { NgModule } from '@angular/core';
import { StorageSessionService } from './services/storage.session.service';
import { StorageCookieService } from './services/storage.cookie.service';
import { StorageLocalService } from './services/storage.local.service';

@NgModule({
	imports: [],
	providers: [StorageSessionService, StorageCookieService, StorageLocalService],
	declarations: []
})
export class StorageModule {}
